import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { TOPIC } from "App/Routes";
import TopicCard from "components/Project/TopicCard";
import ProgressBar from "components/shared/ProgressBar/ProgressBar";
import Link from "components/shared/Link/Link";
import placeholder_topic from "images/core/placeholders/placeholder_topic.jpg";

import Dotdotdot from "react-dotdotdot";

import localize from "lang/localize";

const propTypes = {
  sessionKey: PropTypes.string,
  projectId: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
  allowReset: PropTypes.bool,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  totalChallenges: PropTypes.number.isRequired,
  completedChallenges: PropTypes.number.isRequired,
  img: PropTypes.string.isRequired,
  started: PropTypes.bool.isRequired,
  locked: PropTypes.bool.isRequired,
  expired: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  /* Custom: topic points */
  points: PropTypes.number.isRequired,
  language: PropTypes.string,
};

const defaultProps = {
  isMobile: false,
  allowReset: false,
  img: placeholder_topic,
};

class CustomTopicCard extends TopicCard {
  render() {
    let img = this.props.img;
    let title = this.props.title;

    let topicCardImage = (
      <div
        className="card-img"
        style={{
          backgroundColor: "#fff",
          backgroundImage:
            "linear-gradient(rgba(20,20,20,0.3),rgba(255,255,255,0),rgba(255,255,255,0),rgba(255,255,255,0),rgba(255,255,255,0),rgba(20,20,20,0.3)), url(" +
            img +
            ")",
        }}
      >
        <div className="card-title-wrap">
          <div className="card-title-container">
            <Dotdotdot clamp={3}>{title}</Dotdotdot>
          </div>
        </div>
        {this.renderDropdownButton()}
        <ProgressBar
          completed={this.props.completedChallenges}
          total={this.props.totalChallenges}
          language={this.props.language}
        />
      </div>
    );

    /* Custom: remove description, print points */
    let topicCard = (
      <div className="topic-card card">
        {!this.props.locked && !this.props.expired ? (
          <Link to={TOPIC.format(this.props.id)}>{topicCardImage}</Link>
        ) : (
          topicCardImage
        )}
        <div className="text-align-center verticalpadding-10 horizontalpadding-10">
          <p
            className="nomargin font-size-lg"
            dangerouslySetInnerHTML={{
              __html: localize("points_text", this.props.language).format(
                "<strong>" + this.props.points + "</strong>",
              ),
            }}
          />
        </div>
        {this.renderActionButton()}
      </div>
    );

    /*
      Scrollable anchors inserted only to desktop topic cards.
      This is because mobile and desktop topic cards are rendered
      in the Project component (with either being on display: none
      depending on resolution. Having 2 of the same anchor names to
      search for confuses the ScrollableAnchor library
    */
    if (!this.props.isMobile) {
      return (
        <Fragment>
          {/* Empty span just so we can stack scrollable anchors */}
          <div id={"resettedtopic" + this.props.id}>
            <span></span>
          </div>
          <div id={"topic" + this.props.id}>{topicCard}</div>
          {this.renderResetActivityDialog()}
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          {topicCard}
          {this.renderResetActivityDialog()}
        </Fragment>
      );
    }
  }
}

CustomTopicCard.propTypes = propTypes;
CustomTopicCard.defaultProps = defaultProps;

export default CustomTopicCard;
